<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("OpenOrders") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="topfix">
      <div class="tophead text-center">
        <div
          class="m-t-xs col-xs-6 active"
          v-if="hideotherpair"
          v-on:click="hide()"
        >
          <p class="pointer">
            <i class="m-r-xs fad fa-check-square"></i>
            {{ $t("HideOtherPairs") }}
          </p>
        </div>
        <div class="m-t-xs col-xs-6" v-else v-on:click="hide()">
          <p class="pointer">
            <i class="m-r-xs fad fa-square"></i> {{ $t("HideOtherPairs") }}
          </p>
        </div>
        <div class="col-xs-6">
          <p
            class="pointer btnp"
            v-on:click="cancelall()"
            v-if="openorders.length > 0"
          >
            {{ $t("CancelAll") }}
          </p>
        </div>
      </div>
    </div>

    <div class="loader-example" v-if="!ready">
      <div class="loader-bar"></div>
    </div>
    <div class="container-center lg animated fadeIn" v-else>
      <div v-if="openorders.length > 0">
        <div v-for="b in openorders" v-bind:key="b._id">
          <div class="coin" v-if="b.pair == pair || !hideotherpair">
            <div class="row pointer expand">
              <div class="col-xs-3 text-center">
                <p>
                  <span v-bind:class="'label ' + b.label">{{ b.type }}</span>
                </p>
                <span v-if="b.type == 'SELL'">{{
                  filled(b.volume, b.original_volume)
                }}</span>
                <span v-if="b.type == 'BUY'">{{
                  filled(b.amount, b.original_amount)
                }}</span>
              </div>
              <div class="col-xs-9">
                <div class="row">
                  <div class="col-xs-12">
                    <span class="font-bold c-white"
                      >{{ b.pair.split("_")[0] }}/{{
                        b.pair.split("_")[1]
                      }}</span
                    >
                    <small class="pull-right">{{ b.createdAt }}</small>
                  </div>
                  <div class="col-xs-4">
                    {{ $t("Amount") }}<br />
                    {{ $t("Price") }}
                  </div>
                  <div class="col-xs-8" v-if="b.type == 'SELL'">
                    <span class="c-white">{{
                      volumedigi(b.original_volume - b.volume, b.pair)
                    }}</span
                    >/{{ volumedigi(b.original_volume, b.pair) }}<br />
                    {{ ratedigi(b.rate, b.pair) }}
                    <span
                      class="pointer btnp pull-right"
                      v-on:click="cancel(b._id)"
                    >
                      {{ $t("Cancel") }}
                    </span>
                  </div>
                  <div class="col-xs-8" v-if="b.type == 'BUY'">
                    <span class="c-white">{{
                      volumedigi(
                        (b.original_amount - b.amount) / b.rate,
                        b.pair
                      )
                    }}</span
                    >/{{ volumedigi(b.original_amount / b.rate, b.pair) }}<br />
                    {{ ratedigi(b.rate, b.pair) }}
                    <span
                      class="pointer btnp pull-right"
                      v-on:click="cancel(b._id)"
                    >
                      {{ $t("Cancel") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="container-center lg loader-example text-center">
          <i class="fad fa-search fa-4x"></i>
          <h4>You have no open orders.</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import exchange from "@/api/exchange";
import label from "@/widgets/label";
import moment from "moment";
import nativeToast from "native-toast";

export default {
  data() {
    return {
      pair: null,
      hideotherpair:
        JSON.parse(localStorage.getItem("HideOtherPairs")) || false,
      openorders: [],
      ready: false,
    };
  },
  computed: mapGetters(["getPairing", "getPair"]),
  methods: {
    filled(v, o) {
      return ((o - v) / (o / 100)).toFixed(2) + "%";
    },
    hide() {
      this.hideotherpair = !this.hideotherpair;
      localStorage.setItem(
        "HideOtherPairs",
        JSON.stringify(this.hideotherpair)
      );
    },
    ratedigi(a, pair) {
      if (a) {
        return a.toLocaleString(undefined, {
          minimumFractionDigits: this.getPairing[pair].rate_digi,
        });
      } else {
        return a.toFixed(this.getPairing[pair].rate_digi);
      }
    },
    volumedigi(a, pair) {
      if (a) {
        return a.toLocaleString(undefined, {
          minimumFractionDigits: this.getPairing[pair].volume_digi,
        });
      } else {
        return a.toFixed(this.getPairing[pair].volume_digi);
      }
    },
    getOrders() {
      this.openorders = [];
      exchange
        .openorders()
        .then((res) => {
          this.ready = true;
          res.data.forEach((e) => {
            e.createdAt = moment(e.createdAt).format("YYYY-MM-DD, HH:mm:ss");

            var a = label.type(e.type);
            e.label = a.label;

            this.openorders.push(e);
          });
        })
        .catch((error) => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
    cancel(order_id) {
      if (confirm("Are you sure you want to cancel?")) {
        exchange
          .cancel({
            order_id: order_id,
          })
          .then((response) => {
            nativeToast({
              message: response.data.message,
              position: "top",
              timeout: 3000,
              type: "success",
            });
            this.getOrders();
          })
          .catch((error) => {
            nativeToast({
              message: error.response.data.error,
              position: "top",
              timeout: 3000,
              type: "error",
            });
          });
      }
    },
    cancelall() {
      if (confirm("Are you sure you want to cancel all?")) {
        exchange
          .cancelall()
          .then((response) => {
            nativeToast({
              message: response.data.message,
              position: "top",
              timeout: 3000,
              type: "success",
            });
            this.getOrders();
          })
          .catch((error) => {
            nativeToast({
              message: error.response.data.error,
              position: "top",
              timeout: 3000,
              type: "error",
            });
          });
      }
    },
  },
  created() {
    this.pair = this.getPair;
    this.getOrders();
  },
};
</script>

<style scoped>
.topfix {
  height: 43px;
}
.container-center {
  margin-top: 75px;
  padding: 10px 10px 150px 10px;
}
.coin {
  border-bottom: 1px solid #494b54;
  vertical-align: middle;
  padding: 3px 0;
}
.active p {
  color: #f6a821;
}
.loader-example {
  margin-top: 200px;
}
.btnp {
  padding: 0px 10px;
  display: inline-block;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-image: none;
  border: 1px solid #f6a821;
  border-radius: 0px;
  color: #f6a821;
}
.btnp:hover {
  border: 1px solid #f6a821;
  color: #f6a821;
}
</style>
